<div class="card"  style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;" >
     
  <div class="card-header card-header-primary">
    <div class="row">
      <div class="col-sm-12 col-md-11"><h4 class="card-title"> Comentario </h4></div>
      <div class="col-sm-12 col-md-1"> <button mat-icon-button (click)='salir()' ><mat-icon>clear</mat-icon></button></div>
    </div>
  </div>


  <div class="card-body">
    <div class="wraper">
      <div class="container">
       
            

                        <form [formGroup]='options'>
                          <div class="row" >
                              <div class="col-md-6 col-sm-6  border-right">
                                    <div style="margin-top: 5%">
                                      <mat-form-field>
                                      <mat-label><b>Descripción</b></mat-label>
                                        <textarea matInput aria-label="Descripción" formControlName='descripcionCtrl'
                                          [(ngModel)]="comentario.descripcion" maxlength="2000" rows="6" cols="50"
                                          oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                                      </mat-form-field>
                                      <mat-error
                                        *ngIf=' options.controls.descripcionCtrl.invalid && (options.controls.descripcionCtrl.dirty || options.controls.descripcionCtrl.touched) && options.controls.descripcionCtrl.errors.required'>
                                        El campo es requerido.</mat-error>
                                    </div>
                                    <!-- ********************************Causa Origen Del Problema ********************************************** -->
                                    <div class="row">
                                      <div class="col-md-6 ">
                                        <div style="margin-top: 5%" *ngIf="this.showDatosComplementarios===true && this.data.datos.tipoSolicitud === 'Infraestructura'">
                                          <mat-form-field>
                                            <mat-label><b>Causa Origen Del Problema</b></mat-label>
                                            <textarea matInput aria-label="Causa Origen Del Problema" formControlName='causaProblemaCtrl'
                                              [(ngModel)]="datosTicket.causaOrigenProblema" maxlength="512" rows="2" cols="50"
                                              oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                                          </mat-form-field>
                                        </div>
                                      </div>
                                      <!-- ****************************** Paliativo ************************************************* -->
                                      <div class="col-md-6 ">
                                        <div style="margin-top: 5%" *ngIf="this.showDatosComplementarios===true && this.data.datos.tipoSolicitud === 'Infraestructura'">
                                          <mat-form-field>
                                          <mat-label><b>Paliativo</b></mat-label>
                                            <textarea matInput aria-label="Paliativo" formControlName='paliativoCtrl'
                                              [(ngModel)]="datosTicket.paliativo" maxlength="512" 
                                              oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                                          </mat-form-field>
                                        </div>
                                      </div>
                                    </div>
                                      <!-- ****************************** Solución Definitiva *************************************************** -->
                                      <div class="row">
                                        <div class="col-md-6 ">
                                              <div style="margin-top: 5%" *ngIf="this.showDatosComplementarios===true && this.data.datos.tipoSolicitud === 'Infraestructura'">
                                                <mat-form-field>
                                                <mat-label><b>Solución Definitiva</b></mat-label>
                                                  <textarea matInput aria-label="Solución Definitiva" formControlName='solucionCtrl'
                                                    [(ngModel)]="datosTicket.solucionDefinitiva" maxlength="512" 
                                                    oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                                                </mat-form-field>
                                              </div>
                                            </div>
                                              <!-- ***************************** Impacto Al Negocio ****************************************************** -->
                                            <div class="col-md-6 ">
                                              <div style="margin-top: 5%" *ngIf="this.showDatosComplementarios===true && this.data.datos.tipoSolicitud === 'Infraestructura'">
                                                <mat-form-field>
                                                <mat-label><b>Impacto Al Negocio</b></mat-label>
                                                  <textarea matInput aria-label="Impacto Al Negocio" formControlName='impactoCtrl'
                                                    [(ngModel)]="datosTicket.impacto" maxlength="512" 
                                                    oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                                                </mat-form-field>
                                              </div>
                                        </div>
                                      </div>
                                    <!-- ****************************** Horas ************************************************* -->
                                    <!-- <div class="row">
                                      <div class="col-md-5 col-sm-12">
                                        <div style="margin-top: 5%" *ngIf='this.mostrarHoras===true'>
                                          <mat-form-field>
                                            <input matInput type='text' placeholder="Horas de atención " soloNumeroEntero
                                              [(ngModel)]='datosTicket.horas' maxlength='2' formControlName='horasCtrl'>
                                          </mat-form-field>
                                          <mat-error
                                            *ngIf=' options.controls.horasCtrl.invalid && (options.controls.horasCtrl.dirty || options.controls.horasCtrl.touched) && options.controls.horasCtrl.errors.required'>
                                            El campo es requerido.</mat-error>
                                        </div>
                                      </div>
                                  
                                      <div class="col-md-5 col-sm-12">
                                        <div style="margin-top: 5%" *ngIf='this.mostrarHoras===true'>
                                          <mat-form-field>
                                            <input matInput type='text' placeholder="Minutos de atención " soloNumeroEntero
                                              [(ngModel)]='datosTicket.minutos' pattern='^[0-5][0-9]?$|^59$' maxlength='2'
                                              formControlName='minutosCtrl'>
                                          </mat-form-field>
                                          <mat-error
                                            *ngIf=' options.controls.minutosCtrl.invalid && (options.controls.minutosCtrl.dirty || options.controls.minutosCtrl.touched) && options.controls.minutosCtrl.errors.required'>
                                            El campo es requerido.</mat-error>
                                        </div>
                                      </div>
                                    </div> -->
                                    <!-- ***************************************************************************************** -->
                              </div>  

                              <div class="col-md-6 col-sm-6">

                                    <div class="card">
                                        <div class="card-header card-header-tabs card-header-warning">      
                                                <div class="nav-tabs-navigation">
                                                    <div class="nav-tabs-wrapper">
                                                      <span class="nav-tabs-title">Lista archivos: </span>
                                                      <ul class="nav nav-tabs" data-tabs="tabs"> 
                                                        <li class="nav-item" style="cursor: pointer;">
                                                          <button class=" btn-file nav-link"  style="cursor: pointer;">
                                                            <a style="cursor: pointer;"><i class="material-icons">add_circle_outline </i> Agregar </a>
                                                            <input type="file" id="nameFile" aria-label="Agregar"
                                                              accept="image/*, application/*,file_extension|audio/*|video/mp4,video/*|image/*|media_type" mozdirectory
                                                              directory multiple (change)='subirEv()' />
                                                          </button>
                                                          <div class="ripple-container"></div>
                                                        </li>
                                                        <li class="nav-item" style="cursor: pointer;" [hidden]="btnElimina" >

                                                          <button class="nav-link" (click)="elimina()">
                                                          <a> <i class="material-icons">highlight_off</i> Remover</a>
                                                          </button>                            
                                                          <div class="ripple-container"></div>
                                                        </li>  
                                                      </ul>
                                                    </div>
                                                </div>   
                                        </div>  
                                        <div class="card-body" >
                                            <mat-selection-list style="max-height: 150px; overflow: auto;" [(ngModel)]="selectedOptions"
                                              (ngModelChange)="onNgModelChange($event)" [ngModelOptions]="{standalone: true}">                    
                                              <mat-list-option *ngFor="let item of evidencia; index as i" [value]="item" class="text-muted">
                                                <p class= "text-muted" >{{item.name}} </p>
                                              </mat-list-option>                  
                                            </mat-selection-list>
                                          </div>

                                    </div>  

                                      <!--  <div class="row">
                                          <div class="col-md-6">

                                                  <div class="fileinput fileinput-new text-center" data-provides="fileinput" style="padding-top: 0%">
                                                    <div>
                                                      <p class="text-muted">Evidencia:
                                                        <button class="btn btn-info btn-sm btn-file">
                                                          &nbsp; Agregar
                                                          <input type="file" id="nameFile"
                                                            accept="image/*, application/*,file_extension|audio/*|video/*|image/*|media_type" mozdirectory
                                                            directory multiple (change)='subirEv()' />
                                                        </button>


                                                        <button [disabled]="btnElimina" mat-raised-button class="btn btn-info btn-sm" type="submit"
                                                          (click)="elimina()">
                                                          &nbsp; Eliminar
                                                        </button>
                                                      </p>
                                                    </div>
                                                  </div>

                                          </div> 

                                              <div class="card col-md-5 col-sm-12" style="height: 190px; padding: 0%; padding-top: 0%">
                                                    <div class="card-header card-header-warning">
                                                      <h4 class="card-title">Lista archivos:</h4>
                                                    </div>
                                                    <div class="card-body-responsive" style="height: 0px">
                                                      <mat-selection-list style="max-height: 150px; overflow: auto;" [(ngModel)]="selectedOptions"
                                                        (ngModelChange)="onNgModelChange($event)" [ngModelOptions]="{standalone: true}">
                                                        <mat-list-option *ngFor="let item of evidencia; index as i" [value]="item">
                                                          {{item.name}}
                                                        </mat-list-option>
                                                      </mat-selection-list>
                                                    </div>
                                              </div> 
                                        </div>-->
                              </div>
                          </div>
                      
                          <div mat-dialog-actions class="justify-content-end">
                              <button mat-button class="btn btn-default" (click)="limpiar()">
                                <i class="fa fa fa-trash-o"></i> Limpiar
                              </button>
                              <button mat-button class="btn btn-danger" (click)='salir()'>
                                <i class="fa fa-times-circle-o"></i> Cancelar
                              </button>

                              <button mat-button (click)='guardar()' class="btn  btn-success" [disabled]="!options.valid"
                              onClick="this.disabled=true">
                                Guardar <i class='material-icons'> save </i>
                              </button>
                          
                          </div>
                        </form>
            
        </div>
    </div> 
  </div>    
</div>